import type { OversightRegisterResponse } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';

export const mapTrpcOversightToGraphQL = (
  trpcData: OversightRegisterResponse
): GetOversightAssessmentsQuery => ({
  oversight_assessment: trpcData.oversight.map((item) => ({
    ...item,
    viewers: [],
    viewerGroups: [],
    assessedItems: item.assessmentResults.map((ar) => ({
      riskAssessmentResult: ar.controlledRiskAssessmentResult
        ? {
            Id: ar.controlledRiskAssessmentResult.Id,
            parents: [{ risk: ar.risk }],
          }
        : null,
      obligationAssessmentResult: ar.obligationAssessmentResult
        ? {
            Id: ar.obligationAssessmentResult.Id,
            parents: [{ obligation: ar.obligation }],
          }
        : null,
      documentAssessmentResult: ar.documentAssessmentResult
        ? {
            Id: ar.documentAssessmentResult.Id,
            parents: [{ document: ar.document }],
          }
        : null,
    })),
  })),
});
